import React from 'react'
import {CategoryColumnsProps} from './types'
import ColumnItem from './column-item'

const CategoryColumns: React.FC<CategoryColumnsProps> = ({
    columnItems = [],
    referenceItems = [],
    enableReferenceData = false
}) => {
    const items = enableReferenceData
        ? referenceItems.map((ref) => ({
              isReferenceItem: enableReferenceData,
              referenceID: ref.columnData?.id || '',
              model: ref.columnData?.model || '',
              columnImage: ref.columnData?.value?.data?.imageUpload || '',
              subtitle: ref.columnData?.value?.data?.subtitle || '',
              text: ref.columnData?.value?.data?.text || '',
              ctaText: ref.columnData?.value?.data?.cta || '',
              external: ref.columnData?.value?.data?.external || false,
              external_link: ref.columnData?.value?.data?.external_link || {},
              link: ref.columnData?.value?.data?.link || {}
          }))
        : columnItems

    return (
        <div className="flex flex-row flex-wrap gap-y-[16px] justify-center lg:gap-y-[20px] ">
            {items.map((item, idx) => (
                <div
                    key={idx}
                    className="flex-1 min-w-[220px] lg:max-w-[320px] flex justify-center lg:justify-start"
                >
                    <ColumnItem {...item} />
                </div>
            ))}
        </div>
    )
}

export default CategoryColumns
